import { render, staticRenderFns } from "./CancelOrder.vue?vue&type=template&id=48a08fca&scoped=true&"
import script from "./cancelOrder.js?vue&type=script&lang=js&"
export * from "./cancelOrder.js?vue&type=script&lang=js&"
import style0 from "./CancelOrder.vue?vue&type=style&index=0&id=48a08fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a08fca",
  null
  
)

export default component.exports